// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"812":"abdd51ce","959":"628238a7","978":"8bce55a2","994":"1d1cd0ab"}[chunkId] + ".chunk.css";
};